function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DS = window.WinBoostAiDesignSystem_0f78b0 || {};
var Button = DS.Button,
  IconButton = DS.IconButton,
  Icon = DS.Icon,
  Card = DS.Card,
  Badge = DS.Badge,
  CheckItem = DS.CheckItem,
  SectionLabel = DS.SectionLabel,
  Orbit = DS.Orbit,
  Waveform = DS.Waveform,
  PatternBackdrop = DS.PatternBackdrop,
  StatBlock = DS.StatBlock;
function WfLine(_ref) {
  var ln = _ref.ln,
    style = _ref.style;
  var _ln = _slicedToArray(ln, 2),
    who = _ln[0],
    txt = _ln[1],
    ai = who === 'AI Phone';
  return React.createElement("div", {
    className: "wf-ln",
    style: _objectSpread({
      display: 'flex',
      gap: 8,
      alignItems: 'flex-start'
    }, style)
  }, React.createElement("span", {
    className: "mono wf-who",
    style: {
      width: 62,
      flex: 'none',
      paddingTop: 3,
      color: ai ? 'var(--wb-orange)' : 'var(--ink-500)'
    }
  }, ai ? 'AI' : who === 'Caller' ? 'Lead' : who), React.createElement("span", {
    className: "wf-say",
    style: {
      fontSize: 13.5,
      lineHeight: 1.4,
      padding: '7px 10px',
      borderRadius: 'var(--radius-sm)',
      fontWeight: ai ? 700 : 500,
      color: 'var(--text-primary)',
      background: ai ? 'rgba(252,99,6,.1)' : 'var(--sand-100)',
      border: '1px solid ' + (ai ? 'rgba(252,99,6,.45)' : 'var(--border-card)')
    }
  }, txt));
}
function WfFeed(_ref2) {
  var lines = _ref2.lines,
    n = _ref2.n,
    resetKey = _ref2.resetKey;
  var track = React.useRef(null),
    prev = React.useRef({
      n: 0,
      key: null
    });
  var fv = Math.max(0, n - 2);
  var place = function place(animate) {
    var t = track.current;
    if (!t) return;
    var row = t.children[fv];
    var y = 'translateY(' + -(row ? row.offsetTop : 0) + 'px)';
    if (animate) {
      t.style.transform = y;
      return;
    }
    t.style.transition = 'none';
    t.style.transform = y;
    void t.offsetHeight;
    t.style.transition = '';
  };
  React.useLayoutEffect(function () {
    var p = prev.current;
    place(p.key === resetKey && n >= p.n);
    prev.current = {
      n: n,
      key: resetKey
    };
  }, [n, resetKey]);
  React.useEffect(function () {
    var t = track.current;
    if (!t || typeof ResizeObserver === 'undefined') return;
    var ro = new ResizeObserver(function () {
      return place(false);
    });
    ro.observe(t);
    return function () {
      return ro.disconnect();
    };
  }, [fv, resetKey]);
  var pairs = lines.length < 2 ? [lines] : lines.slice(1).map(function (l, k) {
    return [lines[k], l];
  });
  return React.createElement("div", {
    style: {
      display: 'grid'
    }
  }, pairs.map(function (p, k) {
    return React.createElement("div", {
      key: 'gp' + k,
      "aria-hidden": "true",
      className: "wf-ghost",
      style: {
        gridArea: '1/1',
        visibility: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        gap: 7
      }
    }, p.map(function (ln, j) {
      return React.createElement(WfLine, {
        key: j,
        ln: ln
      });
    }));
  }), React.createElement("div", {
    style: {
      gridArea: '1/1',
      position: 'relative',
      overflow: 'hidden'
    }
  }, React.createElement("div", {
    ref: track,
    style: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: 7,
      transition: 'transform .5s cubic-bezier(.2,.7,.3,1)',
      willChange: 'transform'
    }
  }, lines.map(function (ln, k) {
    var shown = k < n,
      gone = k < fv,
      last = k === n - 1;
    return React.createElement(WfLine, {
      key: k + '|' + ln[1],
      ln: ln,
      style: {
        visibility: shown && !gone ? 'visible' : 'hidden',
        opacity: shown && !gone ? 1 : 0,
        transition: gone ? 'opacity .35s var(--ease-standard,ease),visibility 0s linear .35s' : 'none',
        animation: last ? 'wbStepIn .4s var(--ease-out,cubic-bezier(.2,.7,.3,1)) both' : 'none'
      }
    });
  }))));
}
function WfTyped(_ref3) {
  var text = _ref3.text,
    active = _ref3.active;
  var _React$useState = React.useState(active ? 0 : text.length),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    n = _React$useState2[0],
    setN = _React$useState2[1];
  React.useEffect(function () {
    if (!active) {
      setN(text.length);
      return;
    }
    setN(0);
    var t = setInterval(function () {
      return setN(function (v) {
        if (v >= text.length) {
          clearInterval(t);
          return v;
        }
        return v + 1;
      });
    }, 30);
    return function () {
      return clearInterval(t);
    };
  }, [text, active]);
  return React.createElement(React.Fragment, null, text.slice(0, n), React.createElement("span", {
    style: {
      position: 'relative'
    }
  }, React.createElement("span", {
    "aria-hidden": "true",
    style: {
      position: 'absolute',
      left: 0,
      top: 0,
      opacity: n < text.length ? 1 : 0,
      color: 'var(--wb-charcoal)'
    }
  }, "|")), React.createElement("span", {
    style: {
      visibility: 'hidden'
    }
  }, text.slice(n)));
}
function WfSecs(_ref4) {
  var active = _ref4.active;
  var _React$useState3 = React.useState(0),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    v = _React$useState4[0],
    setV = _React$useState4[1];
  React.useEffect(function () {
    if (!active) return;
    var t = setInterval(function () {
      return setV(function (x) {
        return x >= 82 ? x : x + 8;
      });
    }, 90);
    return function () {
      return clearInterval(t);
    };
  }, [active]);
  return React.createElement(React.Fragment, null, (v / 10).toFixed(1));
}
function SoundRibbon(_ref5) {
  var _ref5$height = _ref5.height,
    height = _ref5$height === void 0 ? 34 : _ref5$height,
    _ref5$active = _ref5.active,
    active = _ref5$active === void 0 ? true : _ref5$active,
    _ref5$tone = _ref5.tone,
    tone = _ref5$tone === void 0 ? 'dark' : _ref5$tone,
    style = _ref5.style;
  var ref = React.useRef(null);
  React.useEffect(function () {
    var cv = ref.current;
    if (!cv) return;
    var ctx = cv.getContext('2d');
    var S = Math.min(2, window.devicePixelRatio || 1);
    var size = function size() {
      var r = cv.getBoundingClientRect();
      cv.width = Math.max(1, Math.round(r.width * S));
      cv.height = Math.max(1, Math.round(r.height * S));
    };
    size();
    window.addEventListener('resize', size, {
      passive: true
    });
    var T = 0,
      last = 0,
      raf = 0,
      run = false;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var paint = function paint() {
      var w = cv.width / S,
        h = cv.height / S,
        cy = h / 2;
      ctx.setTransform(S, 0, 0, S, 0, 0);
      ctx.clearRect(0, 0, w, h);
      var n0 = Math.max(7, Math.round(w * .86 / 6.8)),
        n = n0 % 2 ? n0 : n0 + 1,
        bw = 2.5;
      var pad = w * .07,
        gap = (w - pad * 2 - n * bw) / Math.max(1, n - 1);
      var gt = active ? 1 : 0;
      if (cv.__g == null) cv.__g = gt;
      var dtp = cv.__lt == null ? 0 : Math.min(.1, Math.max(0, T - cv.__lt));
      cv.__lt = T;
      cv.__g += (gt - cv.__g) * Math.min(1, dtp * (gt > cv.__g ? 3.2 : 4.5));
      var g = cv.__g;
      if (!cv.__pm) {
        cv.__pm = 1;
        cv.__pw = 0;
        cv.__px = -1;
        var mv = function mv(e) {
          var r = cv.getBoundingClientRect();
          cv.__px = ((e.touches ? e.touches[0].clientX : e.clientX) - r.left) / r.width;
        };
        cv.addEventListener('pointermove', mv);
        cv.addEventListener('pointerdown', mv);
        cv.addEventListener('pointerleave', function () {
          cv.__px = -1;
        });
      }
      cv.__pw += ((cv.__px >= 0 ? 1 : 0) - cv.__pw) * .12;
      var gr = ctx.createLinearGradient(0, cy - h * .45, 0, cy + h * .45);
      gr.addColorStop(0, '#FC6306');
      gr.addColorStop(1, '#FFAE06');
      ctx.fillStyle = gr;
      var sm = function sm(x) {
        x = Math.max(0, Math.min(1, x));
        return x * x * (3 - 2 * x);
      };
      var rnd = function rnd(q) {
        var x = Math.sin(q * 127.1) * 43758.5453;
        return x - Math.floor(x);
      };
      for (var i = 0; i < n; i++) {
        var u = n > 1 ? i / (n - 1) : .5,
          env = .2 + .8 * Math.exp(-Math.pow((u - .5) / .3, 2));
        var live = .45 + .55 * Math.abs(Math.sin(T * (2 + i % 5 * .7) + i * 1.3) * .65 + Math.sin(T * (3.1 + i % 3 * .9) + i * .7) * .35);
        var talk = env * live * h * .82;
        var ripple = .5 + .5 * Math.sin(i * .42 - T * 3.2),
          peak = Math.pow(Math.max(0, Math.sin(T * 1.1 + rnd(i + 3) * 6.28)), 6);
        var listen = 3 + h * (.05 + .09 * ripple + .16 * peak * (.4 + .6 * env) + .05 * env);
        var bump = cv.__pw * Math.exp(-Math.pow((u - cv.__px) / .1, 2)) * h * .5;
        var mix = sm(g * 1.5 - Math.abs(u - .5) * .6);
        var bh = Math.min(h * .9, Math.max(bw, listen + bump + (talk - listen) * mix));
        var x = pad + i * (bw + gap),
          y = cy - bh / 2;
        ctx.beginPath();
        if (ctx.roundRect) ctx.roundRect(x, y, bw, bh, bw / 2);else ctx.rect(x, y, bw, bh);
        ctx.fill();
      }
    };
    var wbPace = window.WB_PACE ? window.WB_PACE() : null;
    var _frame = function frame(ts) {
      if (wbPace && !wbPace(ts)) {
        if (run) raf = requestAnimationFrame(_frame);
        return;
      }
      var dt = last ? Math.min(.05, (ts - last) / 1000) : .016;
      last = ts;
      T += dt;
      paint();
      if (run) raf = requestAnimationFrame(_frame);
    };
    var io = null;
    if (still || !window.IntersectionObserver) {
      paint();
    } else {
      io = new IntersectionObserver(function (e) {
        if (e[0].isIntersecting && !run) {
          run = true;
          last = 0;
          raf = requestAnimationFrame(_frame);
        } else if (!e[0].isIntersecting && run) {
          run = false;
          cancelAnimationFrame(raf);
        }
      }, {
        threshold: 0
      });
      io.observe(cv);
      paint();
    }
    return function () {
      run = false;
      cancelAnimationFrame(raf);
      if (io) io.disconnect();
      window.removeEventListener('resize', size);
    };
  }, [active]);
  return React.createElement("canvas", {
    ref: ref,
    "aria-hidden": "true",
    style: _objectSpread({
      display: 'block',
      width: '100%',
      height: height
    }, style)
  });
}
var TOOL_MISS = new Set(),
  TOOL_HIT = new Map();
function ToolLogo(_ref6) {
  var name = _ref6.name;
  var slug = name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  var own = slug === 'winboost-ai' || slug === 'knowledge-base' ? A + 'orbit.png' : null;
  var _React$useState5 = React.useState(own || TOOL_HIT.get(slug) || null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    src = _React$useState6[0],
    setSrc = _React$useState6[1];
  React.useEffect(function () {
    if (own) {
      setSrc(own);
      return;
    }
    if (TOOL_HIT.has(slug)) {
      setSrc(TOOL_HIT.get(slug));
      return;
    }
    if (TOOL_MISS.has(slug)) {
      setSrc(null);
      return;
    }
    var domain = ((window.WB_CASES || {}).TOOL_DOMAINS || {})[name];
    var LOCAL_LOGOS = {
      "caller-id": "png",
      "google-business": "png",
      "google-calendar": "png",
      "hubspot": "png",
      "jobber": "png",
      "n8n": "png",
      "slack": "png",
      "stripe": "png",
      "twilio-sms": "png",
      "twilio": "png"
    };
    var srcs = LOCAL_LOGOS[slug] ? [A + 'logos/' + slug + '.' + LOCAL_LOGOS[slug]] : [];
    srcs.splice.apply(srcs, [0, srcs.length].concat(_toConsumableArray(srcs.filter(function (x) {
      return ["caller-id.png", "google-business.png", "google-calendar.png", "hubspot.png", "jobber.png", "n8n.png", "slack.png", "stripe.png", "twilio-sms.png", "twilio.png"].includes(x.split("/").pop());
    }))));
    var dead = false,
      i = 0;
    var _tryNext = function tryNext() {
      if (dead) return;
      if (i >= srcs.length) {
        TOOL_MISS.add(slug);
        setSrc(null);
        return;
      }
      var url = srcs[i++],
        img = new Image();
      img.onload = function () {
        if (!dead) {
          TOOL_HIT.set(slug, url);
          setSrc(url);
        }
      };
      img.onerror = _tryNext;
      img.src = url;
    };
    _tryNext();
    return function () {
      dead = true;
    };
  }, [slug, name, own]);
  var box = {
    width: 30,
    height: 30,
    borderRadius: 8,
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden'
  };
  if (!src) return React.createElement("span", {
    style: _objectSpread(_objectSpread({}, box), {}, {
      background: 'rgba(255,255,255,.09)',
      border: '1px solid var(--border-inverse)',
      fontSize: 11,
      fontWeight: 800,
      color: 'var(--wb-gold)',
      letterSpacing: '-.02em'
    })
  }, name.replace(/[^A-Za-z ]/g, '').split(' ').filter(Boolean).slice(0, 2).map(function (w) {
    return w[0];
  }).join('').toUpperCase());
  return React.createElement("span", {
    style: _objectSpread(_objectSpread({}, box), {}, {
      background: 'var(--wb-white)',
      padding: 3,
      boxSizing: 'border-box'
    })
  }, React.createElement("img", {
    src: src,
    alt: "",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    }
  }));
}
function Workflow() {
  var C = window.WB_CASES;
  var _React$useState7 = React.useState(C.DEFAULT),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    cat = _React$useState8[0],
    setCat = _React$useState8[1];
  var _React$useState9 = React.useState('Inbound'),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    mode = _React$useState0[0],
    setMode = _React$useState0[1];
  var _React$useState1 = React.useState('rev'),
    _React$useState10 = _slicedToArray(_React$useState1, 2),
    sms = _React$useState10[0],
    setSms = _React$useState10[1];
  var _React$useState11 = React.useState(0),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    i = _React$useState12[0],
    setI = _React$useState12[1];
  var _React$useState13 = React.useState(true),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    auto = _React$useState14[0],
    setAuto = _React$useState14[1];
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    vis = _React$useState16[0],
    setVis = _React$useState16[1];
  var started = React.useRef(false);
  var visRef = React.useRef(false);
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    lastDone = _React$useState18[0],
    setLastDone = _React$useState18[1];
  var vid = React.useRef(null);
  var _React$useState19 = React.useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    playing = _React$useState20[0],
    setPlaying = _React$useState20[1];
  var box = React.useRef(null);
  var flow = C.build(cat, mode, sms);
  var steps = flow.steps;
  var title = steps[i][0];
  React.useEffect(function () {
    var el = box.current;
    var inView = function inView() {
      if (!el) return true;
      var r = el.getBoundingClientRect();
      if (!r.height) return true;
      return r.top < window.innerHeight && r.bottom > 0;
    };
    var set = function set(on) {
      if (on && !started.current) {
        started.current = true;
        setI(0);
      }
      visRef.current = on;
      setVis(on);
    };
    if (!el) {
      setVis(true);
      return;
    }
    set(inView());
    var o = null;
    if (window.IntersectionObserver) {
      o = new IntersectionObserver(function (e) {
        return set(e[e.length - 1].isIntersecting);
      }, {
        threshold: 0
      });
      o.observe(el);
    }
    var t = setInterval(function () {
      var on = inView();
      if (on !== visRef.current) set(on);
    }, 400);
    return function () {
      if (o) o.disconnect();
      clearInterval(t);
    };
  }, []);
  var loaded = React.useRef(false);
  React.useEffect(function () {
    var v = vid.current;
    if (!v) return;
    if (!vis) {
      if (loaded.current) v.pause();
      return;
    }
    if (loaded.current) {
      var p = v.play();
      p && p["catch"](function () {});
      return;
    }
    var t = setTimeout(function () {
      var n = vid.current;
      if (!n || loaded.current) return;
      loaded.current = true;
      n.src = n.canPlayType('video/mp4') ? './media/meanwhile.mp4' : './media/meanwhile.webm';
      setPlaying(true);
      var p = n.play();
      p && p["catch"](function () {});
    }, 600);
    return function () {
      return clearTimeout(t);
    };
  }, [vis]);
  React.useEffect(function () {
    if (!auto || !vis) return;
    var t = setInterval(function () {
      return setI(function (p) {
        return (p + 1) % steps.length;
      });
    }, 1900);
    return function () {
      return clearInterval(t);
    };
  }, [auto, vis, cat, mode, sms, steps.length]);
  React.useEffect(function () {
    setLastDone(false);
    if (!vis || i !== steps.length - 1) return;
    var t = setTimeout(function () {
      return setLastDone(true);
    }, title.length * 30 + 120);
    return function () {
      return clearTimeout(t);
    };
  }, [i, vis, title, steps.length]);
  var reset = function reset(fn) {
    fn();
    setI(0);
    setAuto(true);
  };
  var lines = steps.slice(0, i + 1).map(function (s) {
    return s[2];
  }).filter(Boolean).slice(-2);
  var slots = lines.length < 2 ? [null].concat(_toConsumableArray(lines)) : lines;
  var feed = steps.map(function (s) {
      return s[2];
    }).filter(Boolean),
    feedN = steps.slice(0, i + 1).map(function (s) {
      return s[2];
    }).filter(Boolean).length;
  var fields = steps.map(function (s) {
    return s[3];
  });
  var toolRows = ((C.TOOLS || {})[mode] || [])[i] || [];
  var tools = toolRows.concat(Array.from({
    length: Math.max(0, 3 - toolRows.length)
  }, function () {
    return null;
  }));
  var elapsed = 8 + i * 11;
  var isSms = mode === 'SMS';
  var pill = function pill(on) {
    return {
      all: 'unset',
      cursor: 'pointer',
      padding: '9px 17px',
      borderRadius: 999,
      fontSize: 13,
      fontWeight: 800,
      textAlign: 'center',
      transition: 'all var(--dur-base) var(--ease-standard)',
      background: on ? 'var(--grad-brand)' : 'var(--wb-white)',
      color: on ? '#fff' : 'var(--text-secondary)',
      border: '1px solid ' + (on ? 'transparent' : 'var(--border-card)')
    };
  };
  return React.createElement(Section, {
    id: "how-it-fits",
    style: {
      background: 'var(--wb-white)',
      borderTop: '1px solid var(--border-hairline)',
      borderBottom: '1px solid var(--border-hairline)'
    }
  }, React.createElement("style", null, '.wf-stats{position:relative;display:grid;grid-template-columns:repeat(3,minmax(0,1fr));border:1px solid var(--border-card);border-radius:var(--radius-xl);background:var(--wb-white);overflow:hidden;margin:0 7px 23px;box-shadow:0 0 0 6px var(--surface-card-cream),0 0 0 7px var(--border-card),0 1px 2px rgba(23,19,16,.04)}.wf-stat{display:grid;grid-template-rows:auto auto 1fr;align-content:start;padding:clamp(16px,1.7vw,22px) clamp(16px,1.6vw,22px);border-left:1px solid var(--border-hairline);transition:background var(--dur-base) var(--ease-standard)}.wf-stat:first-of-type{border-left:none}.wf-stat:hover{background:var(--grad-brand-soft)}@keyframes wbPip{0%,100%{opacity:.35;transform:scale(.8)}50%{opacity:1;transform:scale(1)}}@keyframes wbFlowRule{0%{background-position:200% 50%}100%{background-position:0% 50%}}.wf-pick{display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,300px),1fr));gap:14px 22px;align-items:end}.wf-stage{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1.15fr);gap:clamp(26px,2.6vw,34px);align-items:stretch;padding:0 7px 7px}.wf-fields{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:6px 16px}.wf-rail{display:grid;gap:clamp(18px,1.8vw,26px);padding:0 7px}.wf-tool{display:flex;align-items:center;gap:12px;opacity:0;animation:wbStepIn .45s cubic-bezier(.2,.7,.3,1) both}.wf-tool-dot{width:8px;height:8px;border-radius:50%;flex:none;background:var(--wb-gold);box-shadow:0 0 0 0 rgba(244,138,29,.5);animation:wbToolPing 1.5s ease-out 3}@keyframes wbToolPing{0%{box-shadow:0 0 0 0 rgba(244,138,29,.55)}70%{box-shadow:0 0 0 7px rgba(244,138,29,0)}100%{box-shadow:0 0 0 0 rgba(244,138,29,0)}}@media(prefers-reduced-motion:reduce){.wf-tool{animation:none;opacity:1}.wf-tool-dot{animation:none}}.wf-step{all:unset;cursor:pointer;position:relative;display:flex;flex-direction:column;gap:10px;padding:12px 12px 14px;border-radius:var(--radius-md);border:1px solid transparent;transition:background var(--dur-base) var(--ease-standard),border-color var(--dur-base) var(--ease-standard)}.wf-step:hover{background:var(--sand-100)}.wf-fw.wf-fw-xl{left:50%;top:50%;z-index:4}.wf-fw.wf-fw-xl i{width:8px;height:8px;margin:-4px;animation-duration:1.9s}.wf-fw.wf-fw-xl b{position:absolute;left:0;top:0;width:4px;height:18px;margin:-9px -2px;border-radius:2px;background:linear-gradient(180deg,var(--wb-cream),var(--wb-gold) 45%,rgba(244,138,29,0));box-shadow:0 0 10px rgba(244,138,29,.85);animation:wbLaunch .46s cubic-bezier(.2,.55,.3,1) forwards}@keyframes wbLaunch{0%{transform:translateY(var(--lift,90px)) scaleY(.5);opacity:0}18%{opacity:1}82%{opacity:1;transform:translateY(calc(var(--lift,90px)*.14)) scaleY(1.2)}100%{transform:translateY(0) scaleY(.35);opacity:0}}.wf-fw{position:absolute;left:20px;top:22px;width:0;height:0;pointer-events:none;z-index:3}.wf-fw i{position:absolute;left:0;top:0;width:5px;height:5px;margin:-2.5px;border-radius:50%;opacity:0;animation:wbSpark 1.15s cubic-bezier(.15,.7,.35,1) forwards}@keyframes wbSpark{0%{transform:translate(0,0) scale(.4);opacity:0}12%{opacity:1;transform:translate(calc(var(--tx)*.18),calc(var(--ty)*.18)) scale(1.1)}70%{opacity:1}100%{transform:translate(var(--tx),calc(var(--ty) + 16px)) scale(.25);opacity:0}}100%{transform:scale(3.4);opacity:0}}.wf-step-row{flex-direction:row!important;align-items:center;gap:9px!important}@media(prefers-reduced-motion:reduce){.wf-fw{display:none}}@media(max-width:1000px){.wf-stage{grid-template-columns:1fr}.wf-fields{grid-template-columns:repeat(3,minmax(0,1fr))}}@media(max-width:760px){.wf-stats{grid-template-columns:1fr}.wf-stat{border-left:none;border-top:1px solid var(--border-hairline)}.wf-stat:first-of-type{border-top:none}.wf-pick{grid-template-columns:1fr}.wf-fields{grid-template-columns:repeat(2,minmax(0,1fr))}.wf-rail{grid-template-columns:repeat(3,minmax(0,1fr))!important}}.wf-auto{position:relative;display:flex;flex-direction:column;gap:6px;margin-top:9px;padding:10px;border-radius:var(--radius-md);border:1px solid rgba(252,99,6,.38);background:linear-gradient(180deg,rgba(252,99,6,.07),rgba(252,99,6,0));overflow:hidden}.wf-auto>.wf-auto-sweep{position:absolute;top:0;bottom:0;left:0;width:55%;pointer-events:none;background:linear-gradient(100deg,transparent,rgba(255,255,255,.55),transparent);will-change:transform;transform:translateX(-100%);animation:wbSweep 2.6s cubic-bezier(.4,0,.2,1) 2 both}@keyframes wbSweep{0%{transform:translateX(-100%)}100%{transform:translateX(220%)}}.wf-auto-pips{display:flex;gap:3px;flex:none}.wf-auto-pips i{width:4px;height:11px;border-radius:2px;background:var(--wb-orange);animation:wbBar .9s var(--ease-standard) 6 both}.wf-auto-pips i:nth-child(2){animation-delay:.15s}.wf-auto-pips i:nth-child(3){animation-delay:.3s}@keyframes wbBar{0%,100%{transform:scaleY(.45);opacity:.5}50%{transform:scaleY(1);opacity:1}}.wf-auto-line{flex:1;min-width:12px;height:1px;background:repeating-linear-gradient(90deg,rgba(244,138,29,.6) 0 5px,rgba(23,19,16,.07) 5px 10px)}.wf-act{position:relative;display:flex;align-items:center;gap:9px;padding:6px 9px 6px 11px;border-radius:var(--radius-sm);background:var(--wb-white);border:1px solid var(--border-card);overflow:hidden;opacity:0;animation:wbActIn .5s cubic-bezier(.2,.7,.3,1) both}@keyframes wbActIn{0%{opacity:0;transform:translateY(9px) scale(.985)}100%{opacity:1;transform:none}}.wf-act-fill{position:absolute;left:0;top:0;bottom:0;width:100%;background:linear-gradient(90deg,rgba(252,99,6,.18),rgba(252,99,6,.02));transform:scaleX(0);transform-origin:left center;animation:wbActFill 1.15s cubic-bezier(.4,0,.2,1) both}@keyframes wbActFill{to{transform:scaleX(1)}}.wf-act-spin{position:relative;flex:none;width:13px;height:13px;border-radius:50%;border:2px solid rgba(252,99,6,.28);border-top-color:var(--wb-orange)}@keyframes wbSpin{to{transform:rotate(360deg)}}@keyframes wbActOut{to{opacity:0;transform:scale(.4)}}.wf-act-wire{position:relative;flex:1;min-width:16px;height:2px;border-radius:2px;overflow:hidden;background:repeating-linear-gradient(90deg,rgba(244,138,29,.85) 0 6px,rgba(23,19,16,.08) 6px 12px)}.wf-act-wire::after{content:"";position:absolute;top:0;bottom:0;left:0;width:40%;background:linear-gradient(90deg,transparent,var(--wb-orange),transparent);will-change:transform;transform:translateX(-100%);animation:wbWire .9s linear 2 both}@keyframes wbWire{to{transform:translateX(300%)}}.wf-act-check{position:relative;flex:none;display:flex;align-items:center;justify-content:center;width:18px;height:18px;border-radius:50%;font-size:11px;font-weight:900;color:#fff;background:var(--wb-green,#168C5A);opacity:0;transform:scale(.4);animation:wbCheckIn .4s cubic-bezier(.2,1.4,.4,1) both}@keyframes wbCheckIn{to{opacity:1;transform:scale(1)}}.wf-meanwhile{display:flex;flex:1 1 auto;align-self:stretch;min-height:0;justify-content:space-between;flex-direction:column;gap:9px;padding:11px;border-radius:var(--radius-lg);background:#171717;border:1px solid #171717}.wf-mw-frame{position:relative;flex:0 1 auto;width:100%;aspect-ratio:9/16;margin-inline:auto;border-radius:calc(var(--radius-md) + 4px);overflow:hidden;background:#292929;border:1px solid #3A3A3A;box-shadow:0 8px 22px -14px rgba(0,0,0,.6)}.wf-mw-vid{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;background:transparent}.wf-mw-play{all:unset;position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:9px;cursor:pointer;background-image:repeating-linear-gradient(135deg,rgba(255,255,255,.07) 0 6px,transparent 6px 12px)}.wf-mw-tri{width:46px;height:46px;border-radius:50%;background:var(--grad-brand,var(--wb-orange));display:flex;align-items:center;justify-content:center;box-shadow:0 6px 18px -8px rgba(0,0,0,.6);transition:transform var(--dur-base) var(--ease-standard)}.wf-mw-tri::after{content:"";border-left:14px solid #fff;border-top:9px solid transparent;border-bottom:9px solid transparent;margin-left:4px}.wf-mw-play:hover .wf-mw-tri{transform:scale(1.07)}@media(prefers-reduced-motion:reduce){.wf-auto>.wf-auto-sweep,.wf-auto-pips i,.wf-act-wire::after,.wf-act-spin{animation:none;display:none}.wf-act,.wf-act-check{animation:none;opacity:1;transform:none}.wf-act-fill{animation:none;width:100%}}'), React.createElement(Head, {
    index: "04",
    label: "Solution & workflow",
    title: "How the AI Phone Lead Closer fits into your business.",
    lead: "While your Siri or Google can set reminders and pick a song for you, WinBoost AI Phones can book meetings and sale to your customers!"
  }), React.createElement("div", {
    className: "wf-stats"
  }, [['Answers after the', '1st', 'ring', 'Every call, every hour, before the lead dials the next name.'], ['Handles', 'Any', 'scenario', 'After hours, two at once, price questions, objections, reservations.'], ['Ends in', 'A Booking', 'or a Sale', 'Not a message for someone to call back tomorrow.']].map(function (_ref7, n) {
    var _ref8 = _slicedToArray(_ref7, 4),
      k = _ref8[0],
      v = _ref8[1],
      unit = _ref8[2],
      d = _ref8[3];
    return React.createElement("div", {
      key: k,
      className: "wf-stat"
    }, React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
      }
    }, React.createElement("span", {
      style: {
        width: 6,
        height: 6,
        borderRadius: '50%',
        flex: 'none',
        background: 'var(--wb-orange)',
        animation: n === 0 ? 'wbPip 1.6s var(--ease-standard) infinite' : 'none',
        opacity: n === 0 ? 1 : .4
      }
    }), React.createElement("span", {
      className: "mono",
      style: {
        letterSpacing: '.16em',
        color: 'var(--ink-500)',
        fontSize: 10
      }
    }, k.toUpperCase())), React.createElement("span", {
      style: {
        display: 'flex',
        alignItems: 'baseline',
        flexWrap: 'wrap',
        columnGap: 5,
        marginTop: 9
      }
    }, React.createElement("span", {
      style: {
        fontSize: 'clamp(26px,2.5vw,36px)',
        fontWeight: 800,
        letterSpacing: '-.04em',
        lineHeight: 1.3,
        paddingBottom: '.06em',
        whiteSpace: 'nowrap',
        background: 'linear-gradient(100deg,var(--wb-gold),var(--wb-orange))',
        WebkitBackgroundClip: 'text',
        backgroundClip: 'text',
        color: 'transparent'
      }
    }, v), n === 2 ? React.createElement(React.Fragment, null, React.createElement("span", {
      style: {
        fontSize: 'clamp(13px,1.1vw,15px)',
        fontWeight: 800,
        color: 'var(--text-secondary)',
        letterSpacing: '-.01em'
      }
    }, "or"), React.createElement("span", {
      style: {
        fontSize: 'clamp(26px,2.5vw,36px)',
        fontWeight: 800,
        letterSpacing: '-.04em',
        lineHeight: 1.3,
        whiteSpace: 'nowrap',
        background: 'linear-gradient(100deg,var(--wb-gold),var(--wb-orange))',
        WebkitBackgroundClip: 'text',
        backgroundClip: 'text',
        color: 'transparent'
      }
    }, "A Sale")) : React.createElement("span", {
      style: {
        fontSize: 'clamp(13px,1.1vw,15px)',
        fontWeight: 800,
        color: 'var(--text-secondary)',
        letterSpacing: '-.01em',
        whiteSpace: 'nowrap'
      }
    }, unit)), React.createElement("span", {
      style: {
        fontSize: 12.5,
        lineHeight: 1.5,
        color: 'var(--text-secondary)',
        marginTop: 7,
        display: 'block'
      }
    }, d));
  })), React.createElement("div", {
    style: {
      borderRadius: 'var(--radius-xl)',
      overflow: 'hidden',
      boxShadow: '0 0 0 6px var(--surface-card-cream),0 0 0 7px var(--border-card),0 20px 50px -26px rgba(23,19,16,.5)',
      margin: '0 7px',
      background: 'linear-gradient(135deg,var(--wb-gold) 0%,var(--wb-orange) 100%)',
      '--text-inverse-muted': 'rgba(23,19,16,.72)',
      '--border-inverse': 'rgba(23,19,16,.22)'
    }
  }, React.createElement("div", {
    className: "wf-pick",
    style: {
      background: 'var(--sand-100)',
      borderBottom: '1px solid var(--border-card)',
      padding: 'clamp(16px,1.6vw,22px)'
    }
  }, React.createElement("label", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8
    }
  }, React.createElement("span", {
    className: "mono",
    style: {
      letterSpacing: '.14em',
      color: 'var(--ink-500)'
    }
  }, "PICK YOUR BUSINESS AI PHONE CATEGORY"), React.createElement("select", {
    value: cat,
    onChange: function onChange(e) {
      return reset(function () {
        return setCat(e.target.value);
      });
    },
    style: {
      font: 'inherit',
      fontFamily: 'var(--font-core)',
      fontSize: 15,
      fontWeight: 600,
      color: 'var(--text-primary)',
      padding: '12px 44px 12px 14px',
      borderRadius: 'var(--radius-md)',
      border: '2px solid var(--wb-orange)',
      background: 'var(--wb-white)',
      cursor: 'pointer',
      appearance: 'none',
      WebkitAppearance: 'none',
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'><circle cx='11' cy='11' r='11' fill='%23FC6306'/><path d='M6.5 9l4.5 4.5L15.5 9' fill='none' stroke='%23fff' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round'/></svg>\")",
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right 12px center',
      backgroundSize: '22px 22px'
    }
  }, C.CATS.map(function (c) {
    return React.createElement("option", {
      key: c,
      value: c
    }, "AI Phone for ", c);
  }))), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8
    }
  }, React.createElement("span", {
    className: "mono",
    style: {
      letterSpacing: '.14em',
      color: 'var(--ink-500)'
    }
  }, "HOW IT IS USED"), React.createElement("div", {
    style: {
      display: 'flex',
      gap: 8,
      flexWrap: 'wrap'
    }
  }, C.MODES.map(function (_ref9) {
    var _ref0 = _slicedToArray(_ref9, 2),
      m = _ref0[0],
      d = _ref0[1];
    return React.createElement("button", {
      key: m,
      onClick: function onClick() {
        return reset(function () {
          return setMode(m);
        });
      },
      title: d,
      style: _objectSpread(_objectSpread({}, pill(mode === m)), {}, {
        whiteSpace: 'nowrap'
      })
    }, m);
  }))), isSms ? React.createElement("div", {
    style: {
      gridColumn: '1 / -1',
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      flexWrap: 'wrap',
      paddingTop: 14,
      borderTop: '1px solid var(--sand-300)'
    }
  }, React.createElement("span", {
    className: "mono",
    style: {
      letterSpacing: '.14em',
      color: 'var(--ink-500)'
    }
  }, "TEXT PURPOSE"), C.SMS_KINDS.map(function (_ref1) {
    var _ref10 = _slicedToArray(_ref1, 2),
      l = _ref10[0],
      k = _ref10[1];
    return React.createElement("button", {
      key: k,
      onClick: function onClick() {
        return reset(function () {
          return setSms(k);
        });
      },
      style: _objectSpread(_objectSpread({}, pill(sms === k)), {}, {
        padding: '8px 15px',
        fontSize: 12
      })
    }, l);
  })) : null), React.createElement("div", {
    ref: box,
    style: {
      position: 'relative',
      padding: 'clamp(16px,1.6vw,22px)'
    }
  }, React.createElement("div", {
    style: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      marginBottom: 10
    }
  }, React.createElement("div", {
    style: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      padding: '0 0 11px',
      borderBottom: '1px solid var(--border-inverse)'
    }
  }, lastDone ? React.createElement("span", {
    className: "wf-fw wf-fw-xl",
    key: 'fwr' + i + cat + mode + sms,
    style: {
      left: '50%',
      top: '50%'
    },
    "aria-hidden": "true"
  }, React.createElement("b", {
    style: {
      '--lift': '70px'
    }
  }), Array.from({
    length: 26
  }, function (_, q) {
    var ang = q / 26 * 6.2832 + .25,
      r = 110 + q % 5 * 46;
    return React.createElement("i", {
      key: q,
      style: {
        '--tx': (Math.cos(ang) * r).toFixed(1) + 'px',
        '--ty': (Math.sin(ang) * r * .5 - 10).toFixed(1) + 'px',
        background: q % 3 === 0 ? 'var(--wb-gold)' : q % 3 === 1 ? 'var(--wb-orange)' : 'var(--wb-cream)',
        animationDelay: .46 + q % 6 * .05 + 's'
      }
    });
  })) : null, React.createElement("div", {
    style: {
      position: 'relative',
      height: 2,
      background: 'var(--border-inverse)',
      borderRadius: 2
    }
  }, React.createElement("div", {
    style: {
      position: 'absolute',
      left: 0,
      top: 0,
      height: 2,
      borderRadius: 2,
      width: (i + 1) / steps.length * 100 + '%',
      background: 'var(--wb-charcoal)',
      transition: 'width var(--dur-slow) var(--ease-standard)',
      boxShadow: 'none'
    }
  })), React.createElement("div", {
    className: "wf-rail",
    style: {
      gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,160px),1fr))',
      alignItems: 'stretch'
    }
  }, steps.map(function (_ref11, k) {
    var _ref12 = _slicedToArray(_ref11, 1),
      s = _ref12[0];
    var on = k === i,
      done = k < i || k === i && lastDone;
    return React.createElement("button", {
      key: s + k,
      onClick: function onClick() {
        setAuto(false);
        setI(k);
      },
      className: "wf-step",
      style: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
        boxSizing: 'border-box',
        boxShadow: '0 0 0 6px var(--surface-card-cream)',
        background: on ? 'var(--sand-100)' : 'var(--wb-white)',
        borderColor: on ? 'var(--wb-orange)' : 'var(--border-card)'
      }
    }, React.createElement("span", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
      }
    }, React.createElement("span", {
      style: {
        width: 26,
        height: 26,
        borderRadius: '50%',
        flex: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 13,
        fontWeight: 800,
        background: on ? 'var(--grad-brand)' : done ? 'rgba(22,140,90,.14)' : 'var(--sand-300)',
        color: on ? '#fff' : done ? 'var(--wb-green,#168C5A)' : 'var(--ink-500)',
        boxShadow: on ? '0 0 0 5px rgba(255,250,245,.35)' : 'none',
        transition: 'all var(--dur-base) var(--ease-standard)'
      }
    }, done ? "\u2713" : k + 1)), React.createElement("span", {
      style: {
        minWidth: 0,
        overflowWrap: 'break-word',
        fontSize: 'clamp(13px,1.15vw,16px)',
        fontWeight: 800,
        lineHeight: 1.3,
        letterSpacing: '-.01em',
        color: 'var(--text-primary)',
        transition: 'color var(--dur-base) var(--ease-standard)'
      }
    }, s));
  }))), React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 16,
      flexWrap: 'wrap'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 12
    }
  }, React.createElement(Badge, {
    tone: "success",
    dot: true,
    pulse: vis
  }, isSms ? 'Live text' : 'Live call'), React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--text-primary)',
      letterSpacing: '.14em',
      fontWeight: 700
    }
  }, String(i + 1).padStart(2, '0'), " / ", String(steps.length).padStart(2, '0'))), React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--text-primary)',
      letterSpacing: '.12em',
      fontWeight: 700
    }
  }, cat.toUpperCase(), " \xB7 ", isSms ? (C.SMS_KINDS.find(function (k) {
    return k[1] === sms;
  }) || ['', ''])[0].toUpperCase() : mode.toUpperCase())), React.createElement("p", {
    style: {
      fontSize: 14,
      lineHeight: 1.45,
      margin: 0,
      fontWeight: 600,
      minHeight: '2.5em',
      color: 'var(--text-primary)'
    }
  }, flow.intro)), React.createElement("div", {
    className: "wf-stage",
    style: {
      minHeight: 0,
      alignItems: 'stretch',
      gridTemplateColumns: 'minmax(0,1.7fr) minmax(0,1fr)'
    }
  }, React.createElement("div", {
    style: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      minWidth: 0,
      minHeight: 0,
      order: 2
    }
  }, React.createElement("div", {
    className: "wf-meanwhile"
  }, React.createElement("p", {
    style: {
      margin: 0,
      textAlign: 'center',
      fontSize: 'clamp(16px,1.4vw,19px)',
      lineHeight: 1.2,
      letterSpacing: '-.02em',
      fontWeight: 800,
      color: '#FFFFFF'
    }
  }, "Meanwhile you ", React.createElement("span", {
    style: {
      background: 'linear-gradient(90deg,#FFAE06,#FC6306)',
      WebkitBackgroundClip: 'text',
      backgroundClip: 'text',
      color: 'transparent'
    }
  }, "WinBoost!")), React.createElement("div", {
    className: "wf-mw-frame"
  }, React.createElement("video", {
    ref: vid,
    className: "wf-mw-vid",
    muted: true,
    loop: true,
    playsInline: true,
    preload: "none",
    style: {
      opacity: playing ? 1 : 0
    },
    onEnded: function onEnded(e) {
      var n = e.currentTarget;
      n.currentTime = 0;
      var p = n.play();
      p && p["catch"](function () {});
    }
  }), playing ? null : React.createElement("button", {
    type: "button",
    className: "wf-mw-play",
    onClick: function onClick() {
      var v = vid.current;
      if (!v) return;
      if (!v.src) {
        v.src = v.canPlayType('video/mp4') ? './media/meanwhile.mp4' : './media/meanwhile.webm';
        v.load();
      }
      setPlaying(true);
      var p = v.play();
      p && p["catch"](function () {});
    }
  }, React.createElement("span", {
    className: "wf-mw-tri",
    "aria-hidden": "true"
  }), React.createElement("span", {
    className: "mono",
    style: {
      fontSize: 10.5,
      letterSpacing: '.14em',
      color: 'rgba(255,250,245,.8)'
    }
  }, "PLAY"))), React.createElement(Button, {
    variant: "primary",
    size: "md",
    arrow: true,
    href: window.WB_PRODUCT_HREF ? window.WB_PRODUCT_HREF('home', 'winboost-now') : '#final-form',
    style: {
      width: '100%',
      justifyContent: 'center'
    }
  }, "WinBoost Now"))), React.createElement("div", {
    style: {
      position: 'relative',
      order: 1,
      border: '1px solid var(--border-card)',
      borderRadius: 'var(--radius-lg)',
      background: 'var(--wb-white)',
      boxShadow: '0 0 0 6px var(--surface-card-cream),0 0 0 7px var(--border-card)',
      padding: '12px 14px',
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      minWidth: 0
    }
  }, lastDone ? React.createElement("span", {
    className: "wf-fw wf-fw-xl",
    key: 'fwt' + i + cat + mode + sms,
    style: {
      left: '50%',
      top: '50%'
    },
    "aria-hidden": "true"
  }, React.createElement("b", {
    style: {
      '--lift': '120px'
    }
  }), Array.from({
    length: 26
  }, function (_, q) {
    var ang = q / 26 * 6.2832 + .4,
      r = 92 + q % 5 * 40;
    return React.createElement("i", {
      key: q,
      style: {
        '--tx': (Math.cos(ang) * r).toFixed(1) + 'px',
        '--ty': (Math.sin(ang) * r * .7 - 12).toFixed(1) + 'px',
        background: q % 3 === 0 ? 'var(--wb-gold)' : q % 3 === 1 ? 'var(--wb-orange)' : 'var(--wb-cream)',
        animationDelay: .46 + q % 6 * .05 + 's'
      }
    });
  })) : null, React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--text-primary)',
      fontSize: 12,
      letterSpacing: '.16em',
      fontWeight: 700
    }
  }, "STEP ", i + 1, " OF ", steps.length), React.createElement("div", {
    style: {
      display: 'grid'
    }
  }, steps.map(function (s, k) {
    return React.createElement("div", {
      key: 'td' + k,
      "aria-hidden": "true",
      className: "wf-ghost",
      style: {
        gridArea: '1/1',
        visibility: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        gap: 8
      }
    }, React.createElement("div", {
      style: {
        fontSize: 'clamp(19px,1.7vw,25px)',
        lineHeight: 1.15,
        letterSpacing: '-.025em',
        fontWeight: 800,
        color: 'var(--wb-charcoal)',
        margin: 0,
        minHeight: '1.2em'
      }
    }, s[0]), React.createElement("div", {
      style: {
        fontSize: 14.5,
        lineHeight: 1.45,
        color: 'var(--text-primary)',
        margin: 0,
        fontWeight: 600,
        minHeight: '2.9em'
      }
    }, s[1]));
  }), React.createElement("div", {
    style: {
      gridArea: '1/1',
      display: 'flex',
      flexDirection: 'column',
      gap: 8
    }
  }, React.createElement("h3", {
    style: {
      fontSize: 'clamp(19px,1.7vw,25px)',
      lineHeight: 1.15,
      letterSpacing: '-.025em',
      fontWeight: 800,
      color: 'var(--wb-charcoal)',
      margin: 0,
      minHeight: '1.2em'
    }
  }, React.createElement(WfTyped, {
    text: title,
    active: vis
  })), React.createElement("p", {
    style: {
      fontSize: 14.5,
      lineHeight: 1.45,
      color: 'var(--text-primary)',
      margin: 0,
      fontWeight: 600,
      minHeight: '2.9em'
    }
  }, steps[i][1]))), React.createElement("div", {
    style: {
      height: 1,
      background: 'var(--border-hairline)'
    }
  }), React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 12
    }
  }, React.createElement(Orbit, {
    size: 34,
    state: vis ? 'speaking' : 'breathing',
    basePath: A
  }), React.createElement("div", {
    style: {
      flex: 1,
      minWidth: 60
    }
  }, React.createElement(SoundRibbon, {
    height: 18,
    active: vis
  })), React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--wb-orange)',
      letterSpacing: '.1em'
    }
  }, Math.floor(elapsed / 60), ":", String(elapsed % 60).padStart(2, '0'))), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 7,
      paddingTop: 10,
      borderTop: '1px solid var(--border-hairline)',
      flex: 'none'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      gap: 10,
      flexWrap: 'wrap'
    }
  }, React.createElement("p", {
    style: {
      margin: 0,
      fontSize: 'clamp(16px,1.5vw,20px)',
      lineHeight: 1.15,
      letterSpacing: '-.02em',
      fontWeight: 800,
      color: 'var(--wb-charcoal)'
    }
  }, isSms ? 'Live text' : 'Live call', ": ", React.createElement("span", {
    style: {
      color: 'var(--wb-orange)'
    }
  }, "AI Phone working autonomously")), React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--ink-500)',
      fontSize: 11,
      letterSpacing: '.14em',
      whiteSpace: 'nowrap'
    }
  }, isSms ? 'LIVE THREAD' : 'LIVE TRANSCRIPT')), React.createElement(WfFeed, {
    lines: feed,
    n: feedN,
    resetKey: cat + '|' + mode + '|' + sms
  })), React.createElement("div", {
    key: 'auto' + i + cat + mode + sms,
    className: "wf-auto"
  }, vis ? React.createElement("span", {
    className: "wf-auto-sweep",
    "aria-hidden": "true"
  }) : null, React.createElement("div", {
    style: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      gap: 10
    }
  }, React.createElement("span", {
    className: "wf-auto-pips",
    "aria-hidden": "true"
  }, React.createElement("i", null), React.createElement("i", null), React.createElement("i", null)), React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--wb-orange)',
      fontSize: 12,
      letterSpacing: '.14em',
      fontWeight: 700
    }
  }, "AUTOMATION RUNNING"), React.createElement("span", {
    "aria-hidden": "true",
    className: "wf-auto-line"
  }), React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--ink-500)',
      fontSize: 11,
      letterSpacing: '.1em',
      whiteSpace: 'nowrap'
    }
  }, toolRows.length, " ", toolRows.length === 1 ? 'ACTION' : 'ACTIONS')), React.createElement("div", {
    style: {
      display: 'grid'
    }
  }, steps.map(function (_, s) {
    return s;
  }).concat(['live']).map(function (s) {
    var rowsS = s === 'live' ? tools : function () {
      var r = ((C.TOOLS || {})[mode] || [])[s] || [];
      return r.concat(Array.from({
        length: Math.max(0, 3 - r.length)
      }, function () {
        return null;
      }));
    }();
    return React.createElement("div", {
      key: 'tl' + s,
      className: s === 'live' ? undefined : 'wf-ghost',
      "aria-hidden": s === 'live' ? undefined : 'true',
      style: {
        gridArea: '1/1',
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        visibility: s === 'live' ? undefined : 'hidden'
      }
    }, rowsS.map(function (row, k) {
      if (!row) return React.createElement("div", {
        key: 'tf' + k,
        className: "wf-act",
        style: {
          visibility: 'hidden',
          animation: 'none',
          opacity: 1,
          minHeight: 31
        },
        "aria-hidden": "true"
      }, React.createElement("span", {
        style: {
          fontSize: 14,
          fontWeight: 800
        }
      }, "\xA0"));
      var _row = _slicedToArray(row, 2),
        tool = _row[0],
        act = _row[1],
        d = k * .34;
      return React.createElement("div", {
        key: tool + k,
        className: "wf-act",
        style: {
          animationDelay: d + 's'
        }
      }, React.createElement("span", {
        className: "wf-act-fill",
        style: {
          animationDelay: d + .18 + 's'
        },
        "aria-hidden": "true"
      }), React.createElement("span", {
        className: "wf-act-spin",
        style: {
          animation: 'wbSpin .75s linear ' + d + 's 2 both, wbActOut .2s var(--ease-standard) ' + (d + 1.15) + 's forwards'
        },
        "aria-hidden": "true"
      }), s === 'live' ? React.createElement(ToolLogo, {
        name: tool
      }) : React.createElement("span", {
        "aria-hidden": "true",
        style: {
          width: 30,
          height: 30,
          flex: 'none'
        }
      }), React.createElement("span", {
        style: {
          position: 'relative',
          fontSize: 15,
          fontWeight: 800,
          color: 'var(--text-primary)',
          whiteSpace: 'nowrap',
          letterSpacing: '-.01em'
        }
      }, tool), React.createElement("span", {
        "aria-hidden": "true",
        className: "wf-act-wire",
        style: {
          animationDelay: d + 's'
        }
      }), React.createElement("span", {
        style: {
          position: 'relative',
          fontSize: 14,
          fontWeight: 700,
          color: 'var(--wb-orange)',
          textAlign: 'right',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          minWidth: 0
        }
      }, act), React.createElement("span", {
        className: "wf-act-check",
        style: {
          animationDelay: d + 1.15 + 's'
        },
        "aria-hidden": "true"
      }, "\u2713"));
    }));
  }))), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 7,
      paddingTop: 11,
      borderTop: '1px solid var(--border-hairline)'
    }
  }, React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--ink-500)',
      fontSize: 12,
      letterSpacing: '.14em'
    }
  }, "CAPTURED ON THE CALL"), React.createElement("div", {
    style: {
      display: 'grid'
    }
  }, [1, 0].map(function (g) {
    return React.createElement("div", {
      key: 'ff' + g,
      className: g ? 'wf-fields wf-ghost' : 'wf-fields',
      "aria-hidden": g ? 'true' : undefined,
      style: {
        gridArea: '1/1',
        visibility: g ? 'hidden' : undefined
      }
    }, fields.map(function (f, k) {
      var got = g ? f : k <= i && f;
      return React.createElement("div", {
        key: k,
        style: {
          display: 'flex',
          flexDirection: 'column',
          opacity: got ? 1 : .32,
          transition: 'opacity var(--dur-base) var(--ease-standard)',
          minWidth: 0
        }
      }, React.createElement("span", {
        className: "mono",
        style: {
          color: 'var(--ink-500)',
          fontSize: 11,
          letterSpacing: '.1em'
        }
      }, f ? f[0] : '…'), React.createElement("span", {
        style: {
          fontSize: 14,
          fontWeight: 800,
          color: 'var(--text-primary)',
          lineHeight: 1.35,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'block'
        }
      }, got ? f[1] : '…'));
    }));
  }))), React.createElement("p", {
    style: {
      position: 'relative',
      minHeight: '3.4em',
      fontSize: 14,
      lineHeight: 1.45,
      margin: 0,
      marginTop: 'auto',
      padding: '9px 12px',
      borderRadius: 'var(--radius-md)',
      background: 'var(--sand-100)',
      border: '1px solid var(--wb-orange)',
      color: 'var(--text-primary)',
      fontWeight: 700,
      display: 'flex',
      alignItems: 'center'
    }
  }, React.createElement("span", {
    style: {
      display: 'grid',
      width: '100%'
    }
  }, steps.map(function (s, k) {
    return React.createElement("span", {
      key: 'oc' + k,
      "aria-hidden": k !== i ? 'true' : undefined,
      style: {
        gridArea: '1/1',
        alignSelf: 'center',
        visibility: k === i ? undefined : 'hidden'
      }
    }, s[4]);
  }))))))), React.createElement(Card, {
    surface: "white",
    padding: "lg",
    className: "wf-ring",
    style: {
      marginTop: 'clamp(20px,2.2vw,30px)',
      border: '2px solid transparent'
    }
  }, React.createElement("style", null, '@property --wf-a{syntax:"<angle>";inherits:false;initial-value:0deg}.wf-ring{background:linear-gradient(var(--wb-white),var(--wb-white)) padding-box,conic-gradient(from var(--wf-a),#FFAE06,#FC6306,#FFAE06 50%,#FC6306,#FFAE06) border-box!important;animation:wfRing 4s linear infinite}@keyframes wfRing{to{--wf-a:360deg}}@media(prefers-reduced-motion:reduce){.wf-ring{animation:none}}'), React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)',
      fontSize: 16
    }
  }, "What happens on the call"), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))',
      gap: 16,
      marginTop: 22
    }
  }, WF_ON_CALL.map(function (s) {
    return React.createElement(CheckItem, {
      key: s
    }, s);
  }))), React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: 24
    }
  }, React.createElement(Button, {
    variant: "primary",
    size: "lg",
    arrow: true,
    href: window.WB_PRODUCT_HREF ? window.WB_PRODUCT_HREF('home', 'get-your-ai-phone') : '#final-form'
  }, "Get Your AI Phone")), React.createElement("div", {
    style: {
      marginTop: 'clamp(20px,2.2vw,30px)'
    }
  }, React.createElement(FounderInsight, null)));
}
var WF_ON_CALL = ['Answers instantly', 'Understands the request', 'Qualifies the prospect', 'Handles objections', 'Checks availability', 'Books the appointment', 'Sends confirmation', 'Collects payments'];
function CallItLive() {
  return React.createElement(Section, {
    id: "hear-it",
    style: {
      background: 'var(--wb-white)',
      borderBottom: '1px solid var(--border-hairline)'
    }
  }, React.createElement("style", null, '@property --wf-a{syntax:"<angle>";inherits:false;initial-value:0deg}@keyframes wfRing{to{--wf-a:360deg}}@media(prefers-reduced-motion:reduce){.cl-card{animation:none}}.cl-intro{display:grid;grid-template-columns:1fr;gap:clamp(28px,3.4vw,56px);align-items:start;margin-bottom:clamp(26px,2.8vw,40px)}@media(max-width:900px){.cl-intro{grid-template-columns:1fr;gap:26px}}.cl-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:clamp(26px,2.4vw,34px);padding:0 7px}@media(max-width:980px){.cl-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}@media(max-width:640px){.cl-grid{grid-template-columns:1fr}}.cl-card{display:flex;flex-direction:column;gap:14px;padding:clamp(18px,1.8vw,24px);border:2px solid transparent;border-radius:var(--radius-lg);background:linear-gradient(var(--wb-white),var(--wb-white)) padding-box,conic-gradient(from var(--wf-a),#FFAE06,#FC6306,#FFAE06 50%,#FC6306,#FFAE06) border-box;animation:wfRing 4s linear infinite;box-shadow:none;transition:border-color var(--dur-base) var(--ease-standard),box-shadow var(--dur-base) var(--ease-standard),transform var(--dur-base) var(--ease-standard)}.cl-card:hover{box-shadow:0 14px 34px rgba(252,99,6,.18);transform:translateY(-3px)}.cl-call{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:auto;padding:11px 14px;border-radius:var(--radius-md);border:1px solid var(--orange-200);background:var(--grad-brand-soft);text-decoration:none}.cl-call:hover{border-color:var(--wb-orange)}.cl-num{font-size:15px;font-weight:800;color:var(--wb-orange);letter-spacing:-.01em}.cl-soon{font-size:13px;font-weight:700;color:var(--ink-400)}.cl-play-wrap{display:flex;flex-direction:column;gap:8px;margin-top:auto}.cl-play{display:flex;align-items:center;gap:10px;width:100%;padding:11px 14px;border-radius:var(--radius-md);border:1px solid var(--orange-200);background:var(--grad-brand-soft);cursor:pointer;font:inherit;text-align:left;transition:border-color var(--dur-base) var(--ease-standard)}.cl-play:hover{border-color:var(--wb-orange)}.cl-play-ic{width:26px;height:26px;flex:none;border-radius:50%;background:var(--wb-orange);color:#fff;display:flex;align-items:center;justify-content:center}.cl-play-t{font-size:13.5px;font-weight:800;color:var(--wb-orange);letter-spacing:-.01em}.cl-bar{display:block;height:3px;border-radius:2px;background:var(--sand-300);overflow:hidden}.cl-bar-fill{display:block;height:100%;background:var(--grad-brand);transition:width .18s linear}'), React.createElement(Head, {
    index: "05",
    label: "Product proof",
    title: "Innovation you can hear, feel and bank on."
  }), React.createElement("div", {
    className: "cl-intro"
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16
    }
  }, React.createElement("h3", {
    className: "h4"
  }, "Hear a real AI Phone call, start to finish."), React.createElement("p", {
    className: "lead"
  }, "Press play on a real call and hear the human-like voice and the clarity for yourself. Think of it as a voice assistant like Siri, but built for your business, and it actually picks up the phone and books your lead."), React.createElement("p", {
    className: "lead"
  }, "Every recording below is from an AI Phone built for that type of business. A new patient asking if you take their insurance, a burst pipe at 2am, a tenant asking to see the unit on Saturday. Real services, real pricing, real booking rules, so what you hear is what your callers hear."))), React.createElement("div", {
    className: "cl-grid"
  }, INDUSTRIES.map(function (_ref13) {
    var _ref14 = _slicedToArray(_ref13, 3),
      ic = _ref14[0],
      name = _ref14[1],
      calls = _ref14[2];
    var label = name.replace(/&[a-z]+;/g, 'and');
    return React.createElement("div", {
      key: name,
      className: "cl-card"
    }, React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 12
      }
    }, React.createElement("span", {
      style: {
        width: 48,
        height: 48,
        flex: 'none',
        borderRadius: 'var(--radius-md)',
        background: 'var(--grad-brand-soft)',
        border: '1px solid var(--orange-200)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }, React.createElement(Icon, {
      name: ic,
      size: 28,
      basePath: ICONS
    })), React.createElement("h3", {
      style: {
        fontSize: 16,
        fontWeight: 800,
        margin: 0,
        letterSpacing: '-.01em',
        lineHeight: 1.2
      },
      dangerouslySetInnerHTML: {
        __html: name
      }
    })), React.createElement("p", {
      style: {
        fontSize: 13.5,
        lineHeight: 1.5,
        color: 'var(--text-secondary)',
        margin: 0
      }
    }, calls), React.createElement(CallRecording, {
      slug: ic,
      label: label
    }));
  })), React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 20,
      flexWrap: 'wrap',
      marginTop: 'clamp(16px,1.8vw,24px)'
    }
  }, React.createElement(Button, {
    variant: "primary",
    size: "lg",
    arrow: true,
    href: window.WB_PRODUCT_HREF ? window.WB_PRODUCT_HREF('home', 'get-your-ai-phone') : '#final-form'
  }, "Get Your AI Phone")));
}
function HearIt() {
  var _React$useState21 = React.useState(false),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    playing = _React$useState22[0],
    setPlaying = _React$useState22[1];
  var steps = ['Answers instantly', 'Understands the request', 'Qualifies the prospect', 'Handles objections', 'Checks availability', 'Books the appointment', 'Sends confirmation'];
  return React.createElement(Section, {
    id: "hear-it"
  }, React.createElement(Head, {
    index: "05",
    label: "Product proof",
    title: "Innovation you can hear, feel and bank on."
  }), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1.3fr 1fr',
      gap: 56,
      alignItems: 'start'
    }
  }, React.createElement("div", null, React.createElement("h3", {
    className: "h4",
    style: {
      marginBottom: 16
    }
  }, "Listen to a real AI Phone conversation."), React.createElement("div", {
    className: "ph",
    style: {
      aspectRatio: '16/9',
      background: 'var(--wb-charcoal)',
      border: '1px solid var(--border-inverse)',
      position: 'relative',
      overflow: 'hidden'
    }
  }, React.createElement(Orbit, {
    size: 140,
    state: playing ? 'speaking' : 'breathing',
    detail: true,
    basePath: A
  }), React.createElement("div", {
    style: {
      position: 'absolute',
      left: 24,
      top: 24,
      display: 'flex',
      gap: 10,
      alignItems: 'center'
    }
  }, React.createElement(Badge, {
    tone: "inverse",
    dot: true,
    pulse: true
  }, "Live call \xB7 00:42")), React.createElement("div", {
    style: {
      position: 'absolute',
      left: 24,
      right: 24,
      bottom: 24,
      display: 'flex',
      alignItems: 'center',
      gap: 16
    }
  }, React.createElement(IconButton, {
    variant: "gradient",
    label: playing ? 'Pause' : 'Play',
    onClick: function onClick() {
      return setPlaying(!playing);
    }
  }, React.createElement("span", {
    style: {
      fontSize: 15,
      fontWeight: 800
    }
  }, playing ? '❙❙' : '▶')), React.createElement(SoundRibbon, {
    height: 26,
    active: playing,
    style: {
      flex: 1
    }
  }), React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--text-inverse-muted)'
    }
  }, "Real recording to be supplied"))), React.createElement("div", {
    className: "grid",
    style: {
      gridTemplateColumns: 'repeat(3,1fr)',
      marginTop: 20
    }
  }, ['Dental: new patient', 'Roofing: quote request', 'Clinic: reschedule'].map(function (t) {
    return React.createElement("div", {
      key: t,
      className: "ph",
      style: {
        aspectRatio: '16/10'
      }
    }, t);
  })), React.createElement("p", {
    className: "lead",
    style: {
      marginTop: 24
    }
  }, "Hear the human-like voice and the clarity on a real call. Think of it as a voice assistant like Siri, but built for your business, and it actually picks up the phone and books your lead.")), React.createElement(Card, {
    surface: "white",
    padding: "lg"
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)'
    }
  }, "What happened on this call"), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      marginTop: 22
    }
  }, steps.map(function (s) {
    return React.createElement(CheckItem, {
      key: s
    }, s);
  })), React.createElement("div", {
    style: {
      marginTop: 26,
      paddingTop: 22,
      borderTop: '1px solid var(--border-hairline)'
    }
  }, React.createElement(Button, {
    variant: "dark",
    arrow: true,
    full: true
  }, "Hear more calls")))));
}
function Reviews() {
  return React.createElement(Section, {
    id: "reviews",
    style: {
      background: 'var(--wb-white)',
      borderTop: '1px solid var(--border-hairline)',
      borderBottom: '1px solid var(--border-hairline)'
    }
  }, React.createElement(Head, {
    index: "17",
    title: React.createElement(React.Fragment, null, "Business owners like you are already growing with their ", React.createElement("span", {
      style: {
        background: 'linear-gradient(90deg,#FFAE06,#FC6306)',
        WebkitBackgroundClip: 'text',
        backgroundClip: 'text',
        color: 'transparent',
        paddingBottom: '.06em'
      }
    }, "WinBoost AI Phone Lead Closer.")),
    lead: "You could be next. Here is what changed for them."
  }), React.createElement("style", null, '.rv-story{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:clamp(14px,1.6vw,22px);margin:0 0 clamp(26px,2.8vw,40px)}@media(max-width:900px){.rv-story{grid-template-columns:minmax(0,1fr)}}.rv-ch{display:flex;flex-direction:column;gap:8px;padding:clamp(18px,1.8vw,24px);border-radius:var(--radius-lg);background:var(--wb-white);border:1px solid var(--border-card)}.rv-ch b{display:inline-flex;align-items:center;gap:10px;font-size:12px;font-weight:800;letter-spacing:.16em;text-transform:uppercase;color:var(--wb-orange)}.rv-ch b i{width:22px;height:2px;border-radius:2px;background:linear-gradient(90deg,#FFAE06,#FC6306)}.rv-ch h3{margin:0;font-size:18px;line-height:1.3;font-weight:800;letter-spacing:-.02em;color:#171717}.rv-ch p{margin:0;font-size:14.5px;line-height:1.6;color:var(--text-secondary)}'), React.createElement("div", {
    className: "rv-story"
  }, React.createElement("div", {
    className: "rv-ch"
  }, React.createElement("b", null, React.createElement("i", null), "Before"), React.createElement("h3", null, "Every missed call was a customer lost."), React.createElement("p", null, "A dentist between patients. A roofer on a ladder. A spa owner mid-treatment. The phone kept ringing and nobody could answer, so new customers called the next business on the list.")), React.createElement("div", {
    className: "rv-ch"
  }, React.createElement("b", null, React.createElement("i", null), "The switch"), React.createElement("h3", null, "The AI Phone picked up on the first ring."), React.createElement("p", null, "Day and night, weekends included, it answered every call in the caller\u2019s language, qualified the lead and booked the appointment straight into their calendar. No voicemail, no callback list.")), React.createElement("div", {
    className: "rv-ch"
  }, React.createElement("b", null, React.createElement("i", null), "Growth"), React.createElement("h3", null, "More bookings, more hours, new markets."), React.createElement("p", null, "Calls that used to be lost became revenue. Owners won back their evenings, and because the AI Phone speaks every language, they started serving customers they could never reach before, across new cities and new countries."))), React.createElement("style", null, '.rv-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:clamp(14px,1.6vw,22px)}@media(max-width:1000px){.rv-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}@media(max-width:520px){.rv-grid{grid-template-columns:minmax(0,1fr)}}.rv-tile{display:flex;flex-direction:column;min-width:0;background:#171717;border-radius:var(--radius-xl);overflow:hidden;transition:transform var(--dur-base) var(--ease-standard),box-shadow var(--dur-base) var(--ease-standard)}.rv-tile:hover{transform:translateY(-4px);box-shadow:0 24px 50px -24px rgba(23,23,23,.55)}.rv-vid{position:relative;aspect-ratio:9/16;background:radial-gradient(80% 50% at 50% 35%,rgba(252,99,6,.22),transparent 70%),#292929;display:grid;place-items:center}.rv-vid video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover}.rv-play{width:58px;height:58px;border-radius:50%;background:linear-gradient(0deg,#FFAE06,#FC6306);display:grid;place-items:center;box-shadow:0 10px 26px -8px rgba(252,99,6,.7)}.rv-ph{position:absolute;left:0;right:0;bottom:14px;text-align:center;font-size:11px;font-weight:800;letter-spacing:.16em;text-transform:uppercase;color:#8A8A8A}.rv-body{display:flex;flex-direction:column;gap:6px;padding:16px 18px 18px}.rv-stat{font-size:16px;font-weight:800;letter-spacing:-.01em;line-height:1.3;color:#FFFFFF}.rv-q{margin:0;font-size:14px;line-height:1.5;color:#C8C8C8}.rv-who{font-size:11.5px;font-weight:800;letter-spacing:.14em;text-transform:uppercase;color:var(--wb-gold)}'), React.createElement("div", {
    className: "rv-grid"
  }, [['Rivera Dental', '+62 calls captured in month one', 'We stopped losing new patients to voicemail.', ''], ['Summit Roofing', '9 hours a week back', 'Quotes get booked while we’re on a roof.', ''], ['Beaumont Spa', '+18% booked revenue', 'Every missed call used to be a lost appointment.', ''], ['Hally Aviation Academy', '14 lessons booked in week one', 'Students book their first flight after hours now.', '']].map(function (r, i) {
    var o = ((window.WB_CONFIG || {}).reviews || [])[i] || {};
    return [o.name || r[0], o.stat || r[1], o.quote || r[2], o.video || r[3]];
  }).map(function (_ref15) {
    var _ref16 = _slicedToArray(_ref15, 4),
      who = _ref16[0],
      stat = _ref16[1],
      quote = _ref16[2],
      src = _ref16[3];
    return React.createElement("div", {
      key: who,
      className: "rv-tile"
    }, React.createElement("div", {
      className: "rv-vid"
    }, src ? React.createElement("video", {
      src: src,
      controls: true,
      playsInline: true,
      preload: "metadata"
    }) : React.createElement(React.Fragment, null, React.createElement("span", {
      className: "rv-play",
      "aria-hidden": "true"
    }, React.createElement("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20"
    }, React.createElement("path", {
      d: "M6 3.5v13l11-6.5z",
      fill: "#FFFFFF"
    }))), React.createElement("span", {
      className: "rv-ph"
    }, "Video story coming soon"))), React.createElement("div", {
      className: "rv-body"
    }, React.createElement("span", {
      className: "rv-stat"
    }, stat), React.createElement("p", {
      className: "rv-q"
    }, "\u201C", quote, "\u201D"), React.createElement("span", {
      className: "rv-who"
    }, who)));
  })));
}
var WB_NOW_PLAYING = null;
function CallRecording(_ref17) {
  var slug = _ref17.slug,
    label = _ref17.label;
  var src = (window.WB_CALL_RECORDING || function () {
    return null;
  })(slug);
  var ref = React.useRef(null);
  var _React$useState23 = React.useState(false),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    playing = _React$useState24[0],
    setPlaying = _React$useState24[1];
  var _React$useState25 = React.useState(0),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    pct = _React$useState26[0],
    setPct = _React$useState26[1];
  if (!src) return React.createElement("div", {
    className: "cl-call",
    style: {
      background: 'var(--sand-100)',
      borderColor: 'var(--sand-300)',
      borderStyle: 'dashed'
    }
  }, React.createElement("span", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 9,
      opacity: .5
    }
  }, React.createElement(Icon, {
    name: "phone-ring",
    size: 18,
    basePath: ICONS
  }), React.createElement("span", {
    className: "cl-soon"
  }, "Recording coming soon")));
  var toggle = function toggle() {
    var a = ref.current;
    if (!a) return;
    if (a.paused) {
      if (WB_NOW_PLAYING && WB_NOW_PLAYING !== a) {
        WB_NOW_PLAYING.pause();
      }
      WB_NOW_PLAYING = a;
      a.play();
    } else a.pause();
  };
  return React.createElement("div", {
    className: "cl-play-wrap"
  }, React.createElement("audio", {
    ref: ref,
    src: src,
    preload: "none",
    onPlay: function onPlay() {
      return setPlaying(true);
    },
    onPause: function onPause() {
      return setPlaying(false);
    },
    onEnded: function onEnded() {
      setPlaying(false);
      setPct(0);
    },
    onTimeUpdate: function onTimeUpdate(e) {
      var a = e.currentTarget;
      if (a.duration) setPct(a.currentTime / a.duration * 100);
    }
  }), React.createElement("button", {
    type: "button",
    className: "cl-play",
    onClick: toggle,
    "aria-label": (playing ? 'Pause' : 'Play') + ' the ' + label + ' AI Phone call recording'
  }, React.createElement("span", {
    className: "cl-play-ic",
    "aria-hidden": "true"
  }, playing ? React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "14",
    height: "14"
  }, React.createElement("rect", {
    x: "5",
    y: "4",
    width: "5",
    height: "16",
    rx: "1.5",
    fill: "currentColor"
  }), React.createElement("rect", {
    x: "14",
    y: "4",
    width: "5",
    height: "16",
    rx: "1.5",
    fill: "currentColor"
  })) : React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "14",
    height: "14"
  }, React.createElement("path", {
    d: "M7 4.8v14.4a1 1 0 0 0 1.52.85l11.2-7.2a1 1 0 0 0 0-1.7L8.52 3.95A1 1 0 0 0 7 4.8Z",
    fill: "currentColor"
  }))), React.createElement("span", {
    className: "cl-play-t"
  }, playing ? 'Playing the call' : 'Tap to hear the AI Phone')), React.createElement("span", {
    className: "cl-bar",
    "aria-hidden": "true"
  }, React.createElement("span", {
    className: "cl-bar-fill",
    style: {
      width: pct + '%'
    }
  })));
}
var INDUSTRIES = [['medical', 'Dental &amp; medical clinics', 'New patient calls, rescheduling, recalls'], ['wrench', 'Home services', 'Emergency dispatch, quote requests, scheduling'], ['house', 'Real estate', 'Listing inquiries, showings, buyer qualification'], ['scales', 'Legal', 'Intake screening, consultation booking'], ['car', 'Auto dealers &amp; repair', 'Service booking, trade-in inquiries'], ['nail', 'Salons &amp; spas', 'Bookings, cancellations, waitlist calls'], ['dumbbell', 'Fitness studios', 'Trial sign-ups, membership questions'], ['finance', 'Financial services', 'Lead qualification, appointment setting'], ['people', 'Agencies', 'Client intake, outbound follow-up at scale']];
function DemoLine(_ref18) {
  var slug = _ref18.slug,
    name = _ref18.name;
  var line = (window.WB_DEMO_LINE || function () {
    return null;
  })(slug);
  return React.createElement("div", {
    className: "ind-call"
  }, React.createElement("span", {
    style: {
      width: 16,
      height: 16,
      flex: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: line ? 1 : .45
    }
  }, React.createElement(Icon, {
    name: "phone-ring",
    size: 16,
    basePath: ICONS
  })), line ? React.createElement(React.Fragment, null, React.createElement("span", {
    style: {
      color: 'var(--text-secondary)',
      fontWeight: 700
    }
  }, "Hear it:"), React.createElement("a", {
    href: line.href,
    "aria-label": 'Call the ' + name.replace(/&[a-z]+;/g, 'and') + ' demo line'
  }, line.display)) : React.createElement("span", {
    className: "ind-soon"
  }, "Demo line coming soon"));
}
function IndustryBand() {
  return React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 14
    }
  }, React.createElement("style", null, '.ind-band{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px}@media(max-width:900px){.ind-band{grid-template-columns:repeat(2,minmax(0,1fr))}}@media(max-width:620px){.ind-band{grid-template-columns:1fr}}.ind-tile{display:grid;grid-template-columns:44px minmax(0,1fr);gap:10px 12px;align-items:center;padding:10px;border:1px solid var(--border-card);border-radius:var(--radius-md);background:var(--wb-white);box-shadow:0 0 0 6px var(--surface-card-cream),0 0 0 7px var(--border-card);transition:border-color var(--dur-base) var(--ease-standard),background var(--dur-base) var(--ease-standard)}.ind-tile:hover{border-color:var(--wb-orange);background:var(--grad-brand-soft)}.ind-call{grid-column:1/-1;display:flex;align-items:center;gap:8px;padding-top:9px;border-top:1px dashed var(--orange-200);font-size:12.5px;font-weight:800}.ind-call a{color:var(--wb-orange);text-decoration:none}.ind-call a:hover{text-decoration:underline}.ind-soon{color:var(--ink-400);font-weight:700}'), React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      gap: 16,
      flexWrap: 'wrap'
    }
  }, React.createElement("span", {
    className: "mono",
    style: {
      letterSpacing: '.14em',
      color: 'var(--ink-500)'
    }
  }, "BUILT FOR BUSINESSES THAT RUN ON CONVERSATIONS"), React.createElement("span", {
    style: {
      fontSize: 13,
      fontWeight: 700,
      color: 'var(--text-secondary)'
    }
  }, "Call any line below to hear a real example of that industry\u2019s AI Phone answering.")), React.createElement("div", {
    className: "ind-band"
  }, INDUSTRIES.map(function (_ref19) {
    var _ref20 = _slicedToArray(_ref19, 3),
      ic = _ref20[0],
      name = _ref20[1],
      calls = _ref20[2];
    return React.createElement("div", {
      key: name,
      className: "ind-tile"
    }, React.createElement("div", {
      style: {
        width: 44,
        height: 44,
        flex: 'none',
        borderRadius: 'var(--radius-md)',
        background: 'var(--grad-brand-soft)',
        border: '1px solid var(--orange-200)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }, React.createElement(Icon, {
      name: ic,
      size: 26,
      basePath: ICONS
    })), React.createElement("div", {
      style: {
        minWidth: 0
      }
    }, React.createElement("h3", {
      style: {
        fontSize: 13.5,
        fontWeight: 800,
        margin: 0,
        letterSpacing: '-.01em',
        lineHeight: 1.25
      },
      dangerouslySetInnerHTML: {
        __html: name
      }
    }), React.createElement("p", {
      style: {
        fontSize: 12,
        lineHeight: 1.4,
        color: 'var(--text-secondary)',
        margin: '3px 0 0'
      }
    }, calls)), React.createElement(DemoLine, {
      slug: ic,
      name: name
    }));
  })));
}
Object.assign(window, {
  Workflow: Workflow,
  CallItLive: CallItLive,
  HearIt: HearIt,
  Reviews: Reviews,
  IndustryBand: IndustryBand,
  SoundRibbon: SoundRibbon
});